export default __webpack_public_path__ + "static/media/hands_behind_head.3b97f669.png";